import { render } from "./actionButton.vue?vue&type=template&id=178bcc78&scoped=true"
import script from "./actionButton.vue?vue&type=script&lang=js"
export * from "./actionButton.vue?vue&type=script&lang=js"

import "./actionButton.vue?vue&type=style&index=0&id=178bcc78&scoped=true&lang=scss"

import exportComponent from "/builds/simply-frontend/simply-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178bcc78"]])

export default __exports__